<div *ngIf="!notifications.permissionsGranted" class="swing-in-top-fwd">
  <!-- <p>
    {{'NOTIFICATIONS_BANNER_COMPONENT.TURN_ON_TO_BE_REMINDED' | translate}}
  </p> -->
  <ion-button (click)="askNotificationPermissions()"expand="block" fill="clear" shape="round">
    <ion-icon style="margin: 0px;" slot="end" name="notifications-off"></ion-icon>
  </ion-button>
</div>
